import React from "react";
import HeaderContact from "./HeaderContact";
import SocialMedia from "./SocialMedia";
import HeaderBrocdure from "./HeaderBrocdure";

const TopHeader = () => {
  return (
    <div className="bg-sport-yellow lg:block md:hidden max-sm:hidden ">
      <div className="flex  items-center container mx-auto justify-between lg:px-12 md:px-4 sm:px-4 max-sm:px-4 ">
        <HeaderContact />
        <div className="flex items-center">
          <SocialMedia />
          <HeaderBrocdure />
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
